// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__12L_l","wrapper":"styles_wrapper__ymXrw"};